import { combineReducers } from "redux"
import projects from "./projects"

const projectReducer = combineReducers({
  projects,
})

export default projectReducer
